import React from 'react'
import Parent from '../components/children/parent/Parent'
import Child from '../components/children/child/Child'
import SecondChild from '../components/children/secondChild/SecondChild'

const ChildrenParent = () => {
  return (
    <div>
        <h1>This is the Parent !</h1>
        <Parent>
          <Child/>
         <SecondChild/>
        </Parent>  
    </div>
  )
}

export default ChildrenParent
